<template>
  <div class="logout">
    <h1 class="subheading light--text">Logout</h1>
  </div>
</template>

<script>
export default {};
</script>
